import merge from 'lodash/merge';
import {
  JOIN_GROUP_SUCCESS,
  UPDATE_GROUP_SUCCESS,
  LEAVE_GROUP_SUCCESS,
  ADD_MEMBERS_TO_GROUP_SUCCESS,
  REQUEST_JOIN_GROUP_SUCCESS,
  WITHDRAW_REQUEST_JOIN_GROUP_SUCCESS,
} from '../actions/current-group-actions';
import {
  RELATIONSHIP_JOINED,
  RELATIONSHIP_NONE,
  RELATIONSHIP_PENDING_APPROVAL,
} from 'groups-common/src/lib/group-relationship-types';

export function currentGroup(state = {}, {type, payload}) {
  switch (type) {
    case JOIN_GROUP_SUCCESS:
      return {
        ...state,
        relationship: RELATIONSHIP_JOINED,
        memberCount: state.memberCount + 1,
      };
    case REQUEST_JOIN_GROUP_SUCCESS:
      return {
        ...state,
        relationship: RELATIONSHIP_PENDING_APPROVAL,
      };
    case WITHDRAW_REQUEST_JOIN_GROUP_SUCCESS:
      return {
        ...state,
        relationship: RELATIONSHIP_NONE,
      };
    case LEAVE_GROUP_SUCCESS:
      return {
        ...state,
        relationship: RELATIONSHIP_NONE,
        memberCount: state.memberCount - 1,
      };
    case UPDATE_GROUP_SUCCESS:
      return merge(state, payload);
    case ADD_MEMBERS_TO_GROUP_SUCCESS:
      return {
        ...state,
        memberCount: state.memberCount + payload.siteMemberIds.length,
      };
    default:
      return state;
  }
}
